import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-perforated-notes',
  templateUrl: './perforated-notes.component.html',
  styleUrls: ['./perforated-notes.component.css']
})
export class PerforatedNotesComponent implements OnInit {

  @Input() fgPerforatedPipe : UntypedFormGroup;

  constructor() { }

  ngOnInit(): void {
  }

}
